import { PrivateUser } from "./types";

// 投票の項目数
export const MIN_VOTE_OPTIONS_COUNT = 2
export const MAX_VOTE_OPTIONS_COUNT = 5

// post_event.application_cancellation_ruleに入る値
export const REFUND = {
  enabled: "1週間前まではキャンセルも返金も可能",
  disabled: "キャンセルはできるが返金不可",
}

// post_event.member_participation_ruleに入る値
export const MEMBER_PARTICIPATE = "グループの会員のみ参加できます。";

export const initialApplicationErrors = (length: number) => {
  return {
    startDate: "",
    endDate: "",
    sections: Array.from({ length: length }, () => {
      return {
        name: "",
        numberOfParticipants: "",
        feeAmount: ""
      }
    })
  }
}

export const initialVoteSettingErrors = (length: number) => {
  return {
    voteQuestion: "",
    voteOptions: Array.from({ length: length}, () => {
      return {
        optionText: "",
      }
    }),
    limitVoteOptions: "",
    expiryDate: "",
  }
}

export const isSamePrivateUser = (privateUser: PrivateUser, userClassName: string, userId: number)=> {
  if (!userClassName || !userId) return false
  return privateUser.userType === userClassName && privateUser.userId === userId
}
